import styled from "styled-components";

export const Container = styled.div`
  grid-column: 1 / -1;
`;

export const ButtonWrapper = styled.div`
  margin-left: auto;
  padding-left: 24px;
`;

export const ToastDescription = styled.div`
  line-height: 24px;
  margin: 8px 0 0;
  font-size: 14px;
  color: var(--mode-text-neutral-default-weak);
  a {
    margin-top: 8px;
  }
`;
